export { default as HotmathHelpPage } from './src/hotmath-help-page';
export { default as HotmathIndexPage } from './src/hotmath-index-page';
